import { render, staticRenderFns } from "./EmailSignUp.vue?vue&type=template&id=c679f828&"
import script from "./EmailSignUp.vue?vue&type=script&lang=js&"
export * from "./EmailSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports